<div [class]="isDialog() ? '' : 'container'">
  <section [class]="isDialog() ? '' : 'section'">
    <div class="list-grid list-header">
      @if (!isSmallSceen()) {
        <app-custom-paginator
          [pageSizeOptions]="isDialog() ? pageSizeDialogOptions : pageSizeOptions"
          [totalLength]="totalSize"
          (page)="onPageChange($event)"
          [(currentPage)]="pageIndex"
          [type]="isDialog() ? 'path-dialog' : 'path'"
        ></app-custom-paginator>
      }
      <mat-form-field class="header-search full-width" appearance="fill">
        <input matInput [(ngModel)]="searchTerm" (keyup)="filter()" autocomplete="off" [placeholder]="'Global.FilterPaths' | translate" />
        <mat-icon matSuffix>filter_list</mat-icon>
      </mat-form-field>
    </div>

    @if (loading) {
      <div class="spinner-wrapper">
        <mat-spinner></mat-spinner>
      </div>
    }

    @if (!isDialog()) {
      <div class="list-grid path-grid mt-1 mb-1" id="addCourse">
        @for (path of pathList; track path._id) {
          <div id="path-card">
            <mat-card appearance="outlined" class="p-0">
              <mat-card-content>
                <mat-card-title class="header">
                  <div class="full-width" (click)="navigate(path)">
                    <strong>{{ path.name | excerpt: 44 }}</strong>
                  </div>
                  @if (path.canBeEdited) {
                    <app-more-button class="mat-icon-btn" [buttons]="path.buttons"></app-more-button>
                  }
                </mat-card-title>
                <div class="text pt-1" (click)="navigate(path)">
                  <p>
                    {{ path.description | excerpt: 210 }}
                  </p>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        }
      </div>
    }

    @if (isDialog()) {
      <div class="container-grey">
        <mat-accordion class="mt-1 mb-1 faq-accordion">
          @for (element of pathList; track element._id; let i = $index) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                @if (element?.name) {
                  <mat-panel-title>
                    {{ element?.name }}
                  </mat-panel-title>
                }
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                @if (element?.description) {
                  <mat-label>{{ element?.description }}</mat-label>
                }
                <div class="content-actions">
                  @if (isDialog()) {
                    <button class="path-button" mat-raised-button color="primary" [disabled]="alreadyInPath(element)" (click)="choosePath(element)">
                      {{ 'Global.Choose' | translate }}
                    </button>
                  }
                </div>
              </ng-template>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    }

    @if (isSmallSceen()) {
      <app-custom-paginator
        [pageSizeOptions]="isDialog() ? pageSizeDialogOptions : pageSizeOptions"
        [totalLength]="totalSize"
        (page)="onPageChange($event)"
        [(currentPage)]="pageIndex"
        [type]="isDialog() ? 'path-dialog' : 'path'"
      ></app-custom-paginator>
    }
  </section>
</div>
